import { Component, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { InvoiceService } from './invoice.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Tracing } from 'trace_events';
import { FinanceDialogDynamicComponent } from '../finance-dialog-dynamic/finance-dialog-dynamic.component';
import { UserData } from './invoice.component';

declare var $: any;
const MaxFileSize =2048000;
// Popup start
@Component({
    selector: 'app-dialog-invoice',
    templateUrl: 'dialog-invoice.html'
})
export class DialogInvoiceComponent {
  public accholdername:any;
  public pub_uniq_id:any;
  public invoice_id:any;
  public month:any;
  public message:any;
  isSpinnerVisible: boolean = false;
  status: any;
  finance_invoice_id: any;
  constructor(
    public dialogRef: MatDialogRef<DialogInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,private fb: FormBuilder,private _invoiceService: InvoiceService
  ) {
    this.pub_uniq_id = data.pubUniqId;
    this.invoice_id = data.invoiceId;
    this.finance_invoice_id=data.financeInvoiceId;
    this.month = data.month;
    this.status=data.status;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  confirmSubmit(){
    if(this.pub_uniq_id!=null && this.invoice_id!=null && this.finance_invoice_id!=null && this.month!=null){
      this.isSpinnerVisible = true;
      this._invoiceService.sendMail(this.pub_uniq_id,this.invoice_id,this.finance_invoice_id,this.month).subscribe(dataResult => {
        if (dataResult['status_code'] == '200') {
          this.onNoClick();
          this.message = "Status paid successfully added.";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        } else {
          this.onNoClick();
          this.message = "Status Paid not set.";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        }
      });
    }else{
      
    }
    
  }
  approveSubmit(){
    if(this.pub_uniq_id!=null && this.finance_invoice_id!=null && this.status!=null){
      this.isSpinnerVisible = true;
      this._invoiceService.approveInvoice(this.pub_uniq_id,this.finance_invoice_id,this.status).subscribe(dataResult => {
        if (dataResult['status_code'] == '200') {
          this.onNoClick();
          this.message = "Status approved successfully.";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        } else {
          this.onNoClick();
          this.message = "Status not approved.";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        }
      });
    }else{
      
    }
    
  }
  disapproveSubmit(){
    if(this.pub_uniq_id!=null && this.finance_invoice_id!=null && this.status!=null){
      this.isSpinnerVisible = true;
      this._invoiceService.dispproveInvoice(this.pub_uniq_id,this.finance_invoice_id,this.status).subscribe(dataResult => {
        if (dataResult['status_code'] == '200') {
          this.onNoClick();
          this.message = "Status disapproved successfully .";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        } else {
          this.onNoClick();
          this.message = "Status Not disapproved.";
          this.dialog.open(FinanceDialogDynamicComponent,
              {
                  width: '450px',
                  data: { message: this.message }
              });
          this.isSpinnerVisible = false;
        }
      });
    }else{
      
    }
    
  }
}
// popup end




